import * as Constant from './constants/actionTypes';
import techConfig from './techConfig';

const homeConfigData = [
  // for single object value always starts with 0;
  {
    title: Constant.LABEL_VIEW_SHARED_CARD,
    Icon: Constant.DIGITAL_CARD_LINK,
    Header: Constant.PAGE_HEADER_DIGITAL_CARD,
    value: 0,
    visible: true,
  },
  {
    title: Constant.LABEL_VIEW_HEALTH_SUMMARY,
    Icon: Constant.MY_HEALTH_SUMMARY_LINK,
    Header: Constant.PAGE_HEADER_HEALTH_SUMMARY,
    value: 1,
    visible: techConfig.IsEnableMyHealthSummaryPDF,
  },
];

export default homeConfigData;
